module.exports = {"id":"212678","name":"Ludwig Augustinsson","rating":"75","photo":"./data/images/photos/0/212678.png","club":{"name":"Werder Brême","logo":"./data/images/clubs/WerderBreme.png"},"positions":["DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LudwigAugustinsson0.json
// module id = 2602
// module chunks = 0